import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Link, LinkIcon } from '../'
import config from '../../config'
import Styles from './PartnerSites.css'

@CSSModules(Styles)
export default class PartnerSites extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props);
  }
  render() {
    return (
      <Link
        to={config.links.fff}
        title='Fossil Free Funds'
      >
        <div styleName='flex'>
          <div styleName='img' />
          <div styleName='copy'>
            <div styleName='title'>
              See the climate impact of your investments with Fossil Free Funds
            </div>
            <div styleName='lede'>
              Fossil fuel investments carry real financial risks. Look up mutual funds and see their exposure to fossil fuel companies and their carbon footprint.
            </div>
            <div styleName='button'>
              Get started<LinkIcon />
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

